import { IModuleTranslation } from '@larscom/ngx-translate-module-loader';
import { trackerMyHP } from './myhp/myhp.interface';
import { trackerType } from './type/type.interface';

const baseTranslateUrl = './assets/i18n/tracker';

export const tracker: Array<IModuleTranslation> = [
  {
    baseTranslateUrl,
    moduleName: 'tracker',
    pathTemplate: '{baseTranslateUrl}/{language}'
  },
  {
    baseTranslateUrl,
    moduleName: 'tracker-connect',
    pathTemplate: '{baseTranslateUrl}/connect/{language}'
  },
  {
    baseTranslateUrl,
    moduleName: 'tracker-disconnect',
    pathTemplate: '{baseTranslateUrl}/disconnect/{language}'
  },
  {
    baseTranslateUrl,
    moduleName: 'tracker-setting',
    pathTemplate: '{baseTranslateUrl}/setting/{language}'
  },
  ...trackerMyHP,
  ...trackerType
];
